import { fetcher } from '@/utils/fetcher'
import useSwr from 'swr'
import { NETWORK_CONFIG } from '@/utils/constants'
import { useMemo } from 'react'
import { useBtcUsd } from '@/lib/quotes/hooks'

const URL = NETWORK_CONFIG?.exchangeRateUrl

/**
 * The BTC/USD rate every dollar figure on the site is priced at.
 *
 * Live first: the quote stream carries bitcoin's mid from Hyperliquid every
 * time it moves, so a USD value anywhere on the page moves with it even
 * when the asset has not traded. The fetched rate is the opening value and
 * the fallback, and it still supplies the 24h change, which the stream does
 * not carry.
 */
export default function useExchangeRate() {
	const { data, isLoading } = useSwr(URL || null, fetcher)
	const live = useBtcUsd()

	return useMemo(
		() =>
			URL
				? {
						exchangeRate: live ?? data?.price,
						percentChange24h: data?.percent_change_24h ?? 0,
						isLoading: isLoading && live === null
				  }
				: { exchangeRate: 21.8, percentChange24h: 0, isLoading: false },
		[data?.price, data?.percent_change_24h, isLoading, live]
	)
}
